import * as Stimulus from "@hotwired/stimulus"

/**
 * Automatically redirects to the link specified
 **/
export class AutoRedirectController extends Stimulus.Controller {
    static values = {
        redirectTime: { type: Number, default: 5000 }
    }

    connect() {
        setTimeout(() => {
            window.location.href = this.element.href;
        }, this.redirectTimeValue)
    }

}
